import MagicLinkConfirm from '../../components/login/MagicLinkConfirm';

const MagicLinkConfirmPortal = (props) => (
  <MagicLinkConfirm {...props} />
);

export default MagicLinkConfirmPortal;
